import { defineStore } from 'pinia'
import { computed, reactive } from 'vue'

import { type BreadcrumbItem } from '@/shared/global/AppBreadcrumbs.vue'

export const useBreadcrumbsStore = defineStore('breadcrumbs', () => {
	/** Array of breadcrumbs per `TRoute` component. Each entry is a _list_ of breadcrumbs to allow a route to add multiple breadcrumbs. */
	const map = reactive(new Map<symbol, BreadcrumbItem[]>())

	const items = computed<Readonly<BreadcrumbItem>[]>(() => {
		return [...map.values()].flat()
	})

	return { map, items }
})
